<div class="selfscroll_body">
  <div class="row t3_template_filter px-4">
    <div class="col-md-4 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1"> Id </div>
        <mat-chip-grid #rulebookRuleIdList>
          <mat-chip-row *ngFor="let type of SelfAssessmentT3FilterModel.rulebookRuleId" [selectable]="selectable" [removable]="removable"
            (removed)="removeRulebookRuleId(type)">
            {{type}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm border-bottom"  id="type" autocomplete="off"
            [matChipInputFor]="rulebookRuleIdList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRulebookRuleId($event)">
        </mat-chip-grid>
      </div>
    </div>

    <div class="col-md-4 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Rule ID </div>
        <mat-chip-grid #ruleIdList>
          <mat-chip-row *ngFor="let type of SelfAssessmentT3FilterModel.ruleId" [selectable]="selectable" [removable]="removable"
            (removed)="removeRuleId(type)">
            {{type}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm border-bottom"  id="type" autocomplete="off"
            [matChipInputFor]="ruleIdList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRuleId($event)">
        </mat-chip-grid>
      </div>
    </div>

    <div class="col-md-3 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Assessor</div>
        <mat-chip-grid #assessorList>
          <mat-chip-row *ngFor="let assessor of assessorFilterList" [selectable]="selectable"
            [removable]="removable" (removed)="removeAssessor(assessor)">
            {{ assessor }}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #assessorInput
            [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete" [matChipInputFor]="assessorList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addAssessor($event)" />
        </mat-chip-grid>
        <mat-autocomplete #assessorAutocomplete="matAutocomplete" (optionSelected)="selectedAssessorEvent($event)">
          <mat-option *ngFor="let fK of searchedAssessor" [value]="fK.value" [title]="fK.name">
            {{ fK.name }}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>

    <div class="col-md-3 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Rule Owner</div>
        <mat-chip-grid #ownerList>
          <mat-chip-row *ngFor="let sQuery of ownerFilterList" [selectable]="selectable"
            [removable]="removable" (removed)="removeOW(sQuery)">
            {{ sQuery }}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #oWInput
            [formControl]="searchOWCntrl" [matAutocomplete]="oWAutocomplete" [matChipInputFor]="ownerList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="addOW($event)" />
        </mat-chip-grid>
        <mat-autocomplete #oWAutocomplete="matAutocomplete" (optionSelected)="selectedOWEvent($event)">
          <mat-option *ngFor="let fK of searchedOwner" [value]="fK.value" [title]="fK.name">
            {{ fK.name }}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    
    <div class="col-lg-4 col-md-4">
      <label class="control-label">LBG Impact
        <!-- <span class="stars">*</span> -->
      </label>
      <mat-select class="select_border" [(ngModel)]="SelfAssessmentT3FilterModel.lbgImpact">
        <mat-option *ngFor="let option of overallAssessmentDropdownList?.lbgList"
          [value]="option == 'Yes' ? true : false">
          {{ option }}
        </mat-option>
      </mat-select>
    </div>
    <div class="col-lg-4 col-md-4">
      <div class="form-group">
        <label class="control-label">RFB Impact
          <!-- <span class="stars">*</span> -->
        </label>
        <mat-select class="select_border" [(ngModel)]="SelfAssessmentT3FilterModel.rfbImpact">
          <mat-option *ngFor="let option of overallAssessmentDropdownList?.rfbList"
            [value]="option == 'Yes' ? true : false">
            {{ option }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="col-lg-4 col-md-4">
      <div class="form-group">
        <label class="control-label">LBCM Impact
          <!-- <span class="stars">*</span> -->
        </label>
        <mat-select class="select_border" [(ngModel)]="SelfAssessmentT3FilterModel.lbcmImpact">
          <mat-option *ngFor="let option of overallAssessmentDropdownList?.lbcmList"
            [value]="option == 'Yes' ? true : false">
            {{ option }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="col-md-4 col-lg-4">
      <label class="control-label">Compliance status</label>
      <mat-chip-grid #complianceStatusList>
        <mat-chip-row *ngFor="let sQuery of csFilterList" [selectable]="selectable"
          [removable]="removable" (removed)="removeCS(sQuery)">
          {{sQuery}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #cSInput
          [formControl]="searchCSCntrl" [matAutocomplete]="cSAutocomplete" [matChipInputFor]="complianceStatusList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="addCS($event)">
      </mat-chip-grid>
      <mat-autocomplete #cSAutocomplete="matAutocomplete" (optionSelected)="selectedCSEvent($event)">
        <mat-option *ngFor="let item of searchedCS" [value]="item">
          {{item}}
        </mat-option>
      </mat-autocomplete>
    </div>
    <div class="col-md-4 col-lg-4">
      <label class="control-label">Assessment status</label>

      <mat-chip-grid #assessmentStatusList>
        <mat-chip-row *ngFor="let sQuery of asFilterList" [selectable]="selectable"
          [removable]="removable" (removed)="removeAS(sQuery)">
          {{sQuery}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #aSInput
          [formControl]="searchASCntrl" [matAutocomplete]="aSAutocomplete" [matChipInputFor]="assessmentStatusList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="addAS($event)">
      </mat-chip-grid>
      <mat-autocomplete #aSAutocomplete="matAutocomplete" (optionSelected)="selectedASEvent($event)">
        <mat-option *ngFor="let item of searchedAS" [value]="item">
          {{item}}
        </mat-option>
      </mat-autocomplete>
    </div>
    <div class="col-md-4 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">Review Date</div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="Reviewpicker" (click)="Reviewpicker.open()" placeholder="Choose a date"
            class="form-control form-control-sm border-bottom" id="reviewDate" placeholder="Review Date"
            [(ngModel)]="SelfAssessmentT3FilterModel.reviewDate" readonly />
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="Reviewpicker.open()"></span>
          </div>
        </div>
        <mat-datepicker #Reviewpicker></mat-datepicker>
      </div>
    </div>    
    <div class="col-md-4 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label mb-1">From Date</div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="Frompicker" (click)="Frompicker.open()" placeholder="Choose a date"
            class="form-control form-control-sm border-bottom" id="fromDate" placeholder="From"
            [(ngModel)]="SelfAssessmentT3FilterModel.fromDate" readonly />
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="Frompicker.open()"></span>
          </div>
        </div>
        <mat-datepicker #Frompicker></mat-datepicker>
      </div>
    </div>

    <div class="col-md-4 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label d-none d-sm-block mb-1">
          To Date
        </div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
            class="form-control form-control-sm border-bottom" id="toDate" placeholder="To"
            [(ngModel)]="SelfAssessmentT3FilterModel.toDate" readonly />
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
          </div>
        </div>
        <mat-datepicker #toPicker></mat-datepicker>
      </div>
    </div>    
    <div class="col-md-4 col-lg-4">
      <div class="form-group">
        <div class="left inline control-label">Next Assessment due</div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="Duepicker" (click)="Duepicker.open()" placeholder="Choose a date"
            class="form-control form-control-sm select_border" id="reviewDate" placeholder="Review Date"
            [(ngModel)]="SelfAssessmentT3FilterModel.nextassessmentDue" readonly />
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="Duepicker.open()"></span>
          </div>
        </div>
        <mat-datepicker #Duepicker></mat-datepicker>
      </div>
    </div>



  </div>
</div>
<div class="col-12 pt-3">
  <div class="form-group mb-0 text-right">
    <span class="ml-2 btn btn-sm pl-1" (click)="resetFilters()">Reset</span>
    <button type="button" class="btn btn-sm bg-purple text-white ml-2 btn-blue text-white" id="btn-search"
      (click)="submitAction()">
      Submit
    </button>
  </div>
</div>
<div class="row regulatory_row"></div>
